<script>
import { mapState } from 'vuex'
import MessageContentText from '@/components/message/MessageContentText.vue'
import MessageContentPayload from '@/components/message/MessageContentPayload.vue'
import MessageContentCarousel from '@/components/message/MessageContentCarousel.vue'
import MessageContentImage from '@/components/message/MessageContentImage.vue'
import MessageContentFile from '@/components/message/MessageContentFile.vue'
import MessageContentQuickReply from '@/components/message/MessageContentQuickReply.vue'
import { sync } from 'vuex-pathify'
import MessageContentRating from '@/components/message/MessageContentRating.vue'

const msgContent = {
    text: MessageContentText,
    payload: MessageContentPayload,
    carousel: MessageContentCarousel,
    image: MessageContentImage,
    file: MessageContentFile,
    quick_reply: MessageContentQuickReply,
    zalo_list_template: MessageContentImage,
    rating: MessageContentRating
}
export default {
    name: 'MessageBox',
    props: {
        history: {
            type: Object,
            default: null
        },
        nextHistory: {
            type: Object,
            default: null
        }
    },
    computed: {
        ...mapState('debug', ['sender']),
        requestId: sync('debug/request_id'),
        isVisitorMsg () {
            return this.history.source === 1 // RECEIVE
        },
        isBotMsg () {
            return this.history.type !== 3 && this.history.source === 2
        },
        isAgentMsg () {
            return this.history.source === 2 && this.history.type === 3
        },
        message () {
            return JSON.parse(this.history.message)
        },
        messageContentComponent () {
            return msgContent[this.message.type]
        },
        messageContent () {
            return typeof this.message.content === 'string' ? JSON.parse(this.message.content) : this.message.content
        },
        isShowMsg () {
            return Object.keys(msgContent).includes(this.message.type)
        },
        isSelectedMsg () {
            return this.requestId === this.history.request_id
        }
    },
    methods: {
        onSelectMsg () {
            if (this.isVisitorMsg && this.history.request_id) {
                this.requestId = this.history.request_id
            }
        }
    }
}
</script>

<template>
    <div class="d-flex flex-column" v-if="isShowMsg">
        <div class="msg-box pa-3"
             :class="{'flex-row': isVisitorMsg, 'flex-row-reverse': !isVisitorMsg, 'msg-box-clickable': isVisitorMsg, 'active': isSelectedMsg}"
             @click="onSelectMsg">
            <div style="width: 40px; height: 40px;">
                <v-avatar size="40" color="#96D3ED" class="white--text caption font-weight-bold" v-if="isVisitorMsg">
                    {{ sender.sender_name | avatarName }}
                </v-avatar>
                <v-avatar size="40" color="#716FFF" v-if="isBotMsg">
                    <svg style="width: 24px; height: 24px" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                         viewBox="0 0 24 24" fill="none">
                        <path
                            d="M13.5 2C13.5 2.44425 13.3069 2.84339 13 3.11805V5H18C19.6569 5 21 6.34315 21 8V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V8C3 6.34315 4.34315 5 6 5H11V3.11805C10.6931 2.84339 10.5 2.44425 10.5 2C10.5 1.17157 11.1716 0.5 12 0.5C12.8284 0.5 13.5 1.17157 13.5 2ZM0 10H2V16H0V10ZM24 10H22V16H24V10ZM9 14.5C9.82843 14.5 10.5 13.8284 10.5 13C10.5 12.1716 9.82843 11.5 9 11.5C8.17157 11.5 7.5 12.1716 7.5 13C7.5 13.8284 8.17157 14.5 9 14.5ZM16.5 13C16.5 12.1716 15.8284 11.5 15 11.5C14.1716 11.5 13.5 12.1716 13.5 13C13.5 13.8284 14.1716 14.5 15 14.5C15.8284 14.5 16.5 13.8284 16.5 13Z"
                            fill="white"/>
                    </svg>
                </v-avatar>
                <v-avatar size="40" color="#9D9C9E" v-if="isAgentMsg">
                    <svg style="width: 24px; height: 24px" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                         viewBox="0 0 24 24" fill="none">
                        <path
                            d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"
                            fill="white"/>
                    </svg>
                </v-avatar>
            </div>
            <component class="msg-content" :is="messageContentComponent" :content="messageContent"
                       :isVisitor="isVisitorMsg" :time="history.created_time"/>
        </div>
        <el-divider v-if="nextHistory && nextHistory.session_id !== history.session_id">
            <span class="session-time">{{nextHistory.created_time | formatDateTimeISO}}</span>
        </el-divider>
    </div>
</template>

<style scoped lang="scss">
.msg-box {
    display: flex;
    gap: 10px;
}

.msg-box-clickable {
    cursor: pointer;
    margin: 0 12px;

    &:hover {
        background: #E4D7FC;
        border-radius: 4px;
    }

    &.active {
        border-radius: 4px;
        border: 1px solid var(--0052-cc, #0052CC);
        background: #E4D7FC;
    }
}
.session-time {
    font-size: 12px;
    background-color: #eaeaea;
    padding: 2px 5px;
    color: #a1a1a1;
    border-radius: 4px;
}
</style>
